module.exports = __webpack_public_path__ + "img/Skirt-Front-B4-Da-Fc-Ge-Hc-Ia.1ad04c42.png";